import Vue from 'vue';
import VueI18n from 'vue-i18n';
import "Components/Ecom/ProductMatrix/ProductMatrixComponent";
import store from "../Store/store";
import Vuelidate from 'vuelidate';
import { languages } from '../../locales';
import PorterBudgetStore from '../Store/porterBudget/porterBudget';

Vue.use(VueI18n);
Vue.use(Vuelidate);

export interface IVueProviderConfig {
    locale: string,
    currencyCode: string,
    currencyLeft: boolean,
    currencySpacing: boolean,
    currencySymbol: string,
    currencyDecimalDigits : number,
    currencyDecimalSeparator: string,
    currencyGroupSeparator: string,
    dateFormatShort: string,
    isPorter: boolean,
    porterNo: string
}

// Create a new Vue instance for the event bus
export const EventBus = new Vue();

// Set the event bus instance on the Vue prototype
Vue.prototype.$eventBus = EventBus;

export class VueProvider {
    private static config: IVueProviderConfig;
    private static i18n: VueI18n;

    static init(config : IVueProviderConfig): void {
        this.config = config;
        const i18n = new VueI18n({
            locale: config.locale,
            fallbackLocale: 'en-BE',
            messages: Object.assign(languages)
        });

        PorterBudgetStore.commitPorterIdUpdated(config.porterNo);
        PorterBudgetStore.commitIsPorterUpdated(config.isPorter);



        Vue.filter('currency', (value: string, skipSymbol : boolean): string => {
            if (!value) return '';
            let valueFloat = parseFloat(value);
            if (isNaN(valueFloat)) return '';
            //return this.i8n.n(valueFloat);

            let result = this.numberFormatting(valueFloat, config.currencyDecimalDigits, config.currencyDecimalSeparator, config.currencyGroupSeparator);

            if (!skipSymbol) {
                result = (config.currencyLeft ? (config.currencySymbol + (config.currencySpacing ? ' ' : '')) : '')
                    + result
                    + (!config.currencyLeft ? (config.currencySpacing ? ' ' : '') + config.currencySymbol : '')
            }
            return result;
        });
        Vue.filter('shortdate', (value: string): string => {
            let date = new Date(value);
            return config.dateFormatShort
                .replace('dd', this.ensureZeros(date.getDate(),2))
                .replace('MM', this.ensureZeros(date.getMonth() + 1, 2))
                .replace('yyyy', this.ensureZeros(date.getFullYear(),4).toString());
        });

        new Vue({
            el: '#app',
            i18n,
            store,
            data: {},
            methods: {},
        });
    }


    static getInstance(): Vue.VueConstructor {
        let norriqVue = Vue.extend({
            i18n: this.i18n
        });
        return norriqVue;
    }

    static ensureZeros(val: number, size : number): string {
        var s = "000000000" + val;
        return s.substr(s.length - size);
    }

    static numberFormatting(number: number, decimals : number, dec_point : string, thousands_sep : string): string {
        var n = !isFinite(+number) ? 0 : +number,
            prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
            sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
            dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
            toFixedFix = (n : number, prec : number) => {
                // Fix for IE parseFloat(0.55).toFixed(0) = 0;
                var k = Math.pow(10, prec);
                return Math.round(n * k) / k;
            },
            s = (prec ? toFixedFix(n, prec) : Math.round(n)).toString().split('.');
        if (s[0].length > 3) {
            s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }
        if ((s[1] || '').length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1).join('0');
        }
        return s.join(dec);
    }

}

